import { onDocumentReady } from '../utils/events';
import Splide from '@splidejs/splide';
import { AdjustableHeight } from '../utils/splide-auto-height';

onDocumentReady(() => {
  const sliderEl = document.querySelector('.certifications__items--slider');

  if (sliderEl) {
    const splide = new Splide(sliderEl, {
      type: 'loop',
      perMove: 1,
      perPage: 4,
      gap: '1.375rem',
      drag: true,
      flickPower: 150,
      dragMinThreshold: {
        mouse: 40,
        touch: 70,
      },
      arrows: true,
      pagination: true,
      keyboard: 'focused',
      rewind: true,
      focus: 0,
      breakpoints: {
        1350: {
          perPage: 3,
        },
        1024: {
          perPage: 2,
          gap: '1.25rem',
        },
        640: {
          perPage: 1,
          pagination: false,
        },
      },
    });

    splide.mount({ AdjustableHeight });
  }
});
